module.exports = __webpack_public_path__ + "static/media/shield.c4fb9679.svg";